// extracted by mini-css-extract-plugin
export default {"gateTabsDates":"_562b2dc298086883"};